export enum PERMISSIONS_STATUS {
  LOADING = 0,
  GRANTED = 1,
  DENIED = 2,
}